<fin-purchase-checkout
  [serviceName]="'web_mmb_ancillary'"
  [paymentFlow]="paymentFlow"
  [isEnableFeedbackMMB]="true"
></fin-purchase-checkout>
